import { render, staticRenderFns } from "./EmployerRegistrationReview.vue?vue&type=template&id=759106e2&"
import script from "./EmployerRegistrationReview.vue?vue&type=script&lang=ts&"
export * from "./EmployerRegistrationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports